var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: _vm.routerName, params: { id: _vm.itemId}}},scopedSlots:_vm._u([{key:"default",fn:function({href, route, navigate}){return [_c('b-button',{attrs:{"variant":"warning","size":"sm"},on:{"click":navigate}},[_c('font-awesome-icon',{attrs:{"icon":"pen"}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }